import { render, staticRenderFns } from "./infoShipmentForm.vue?vue&type=template&id=0ba73bc3"
import script from "./infoShipmentForm.vue?vue&type=script&lang=js"
export * from "./infoShipmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports